// extracted by mini-css-extract-plugin
export default {"mainSection":"addEditCVRecordWrapper_mainSection__IGiXM","actions":"addEditCVRecordWrapper_actions__m8mXC"};